// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Location__bubble-ad153a {
  width: 100vw;
  max-width: 100%;
}

.Location__map-f7dc15 {
  width: 100%;
  height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Location/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF","sourcesContent":[".bubble {\n  width: 100vw;\n  max-width: 100%;\n}\n\n.map {\n  width: 100%;\n  height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `Location__bubble-ad153a`,
	"map": `Location__map-f7dc15`
};
module.exports = ___CSS_LOADER_EXPORT___;
